export const ordersTypes = {
    FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
    FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
    FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
    FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
    FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
    FETCH_ERRORS_REQUEST: "FETCH_ERRORS_REQUEST",
    FETCH_ERRORS_SUCCESS: "FETCH_ERRORS_SUCCESS",
    FETCH_ERRORS_FAILURE: "FETCH_ERRORS_FAILURE",
    FETCH_ERROR_CONTENT_REQUEST: "FETCH_ERROR_CONTENT_REQUEST",
    FETCH_ERROR_CONTENT_SUCCESS: "FETCH_ERROR_CONTENT_SUCCESS",
    FETCH_ERROR_CONTENT_FAILURE: "FETCH_ERROR_CONTENT_FAILURE",
    DELETE_ERROR_REQUEST: "DELETE_ERROR_REQUEST",
    DELETE_ERROR_SUCCESS: "DELETE_ERROR_SUCCESS",
    DELETE_ERROR_FAILURE: "DELETE_ERROR_FAILURE",
    RETRY_ERROR_REQUEST: "RETRY_ERROR_REQUEST",
    RETRY_ERROR_SUCCESS: "RETRY_ERROR_SUCCESS",
    RETRY_ERROR_FAILURE: "RETRY_ERROR_FAILURE",
    FETCH_UNCOMPLETED_REQUEST: "FETCH_UNCOMPLETED_REQUEST",
    FETCH_UNCOMPLETED_SUCCESS: "FETCH_UNCOMPLETED_SUCCESS",
    FETCH_UNCOMPLETED_FAILURE: "FETCH_UNCOMPLETED_FAILURE",
    NORMALIZE_REQUEST: "NORMALIZE_REQUEST",
    NORMALIZE_SUCCESS: "NORMALIZE_SUCCESS",
    NORMALIZE_FAILURE: "NORMALIZE_FAILURE",
    FETCH_TIMESERIES_REQUEST: "FETCH_TIMESERIES_REQUEST",
    FETCH_TIMESERIES_SUCCESS: "FETCH_TIMESERIES_SUCCESS",
    FETCH_TIMESERIES_FAILURE: "FETCH_TIMESERIES_FAILURE",
}

export const restaurantsTypes = {
    FETCH_ALL_CONCEPTS_REQUEST: "FETCH_ALL_CONCEPTS_REQUEST",
    FETCH_ALL_CONCEPTS_SUCCESS: "FETCH_ALL_CONCEPTS_SUCCESS",
    FETCH_ALL_CONCEPTS_FAILURE: "FETCH_ALL_CONCEPTS_FAILURE",
    FETCH_ALL_KITCHENS_REQUEST: "FETCH_ALL_KITCHENS_REQUEST",
    FETCH_ALL_KITCHENS_SUCCESS: "FETCH_ALL_KITCHENS_SUCCESS",
    FETCH_ALL_KITCHENS_FAILURE: "FETCH_ALL_KITCHENS_FAILURE",
    FETCH_ALL_PLATFORMS_REQUEST: "FETCH_ALL_PLATFORMS_REQUEST",
    FETCH_ALL_PLATFORMS_SUCCESS: "FETCH_ALL_PLATFORMS_SUCCESS",
    FETCH_ALL_PLATFORMS_FAILURE: "FETCH_ALL_PLATFORMS_FAILURE",
    FETCH_ALL_COUNTRIES_REQUEST: "FETCH_ALL_COUNTRIES_REQUEST",
    FETCH_ALL_COUNTRIES_SUCCESS: "FETCH_ALL_COUNTRIES_SUCCESS",
    FETCH_ALL_COUNTRIES_FAILURE: "FETCH_ALL_COUNTRIES_FAILURE",
    FETCH_ALL_LOCATIONS_REQUEST: "FETCH_ALL_LOCATIONS_REQUEST",
    FETCH_ALL_LOCATIONS_SUCCESS: "FETCH_ALL_LOCATIONS_SUCCESS",
    FETCH_ALL_LOCATIONS_FAILURE: "FETCH_ALL_LOCATIONS_FAILURE",
}

export const normalizerTypes = {
    FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
    FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
    LABELIZE_REQUEST: "LABELIZE_REQUEST",
    LABELIZE_SUCCESS: "LABELIZE_SUCCESS",
    LABELIZE_FAILURE: "LABELIZE_FAILURE",
    DELETE_UNLABELLED_REQUEST: "DELETE_UNLABELLED_REQUEST",
    DELETE_UNLABELLED_SUCCESS: "DELETE_UNLABELLED_SUCCESS",
    DELETE_UNLABELLED_FAILURE: "DELETE_UNLABELLED_FAILURE",
    APPLY_STATUS: "APPLY_STATUS",
}

export const itemsTypes = {
    FETCH_ALL_COMBOS_REQUEST: "FETCH_ALL_COMBOS_REQUEST",
    FETCH_ALL_COMBOS_SUCCESS: "FETCH_ALL_COMBOS_SUCCESS",
    FETCH_ALL_COMBOS_FAILURE: "FETCH_ALL_COMBOS_FAILURE",
    FETCH_ALL_MENU_ITEMS_REQUEST: "FETCH_ALL_MENU_ITEMS_REQUEST",
    FETCH_ALL_MENU_ITEMS_SUCCESS: "FETCH_ALL_MENU_ITEMS_SUCCESS",
    FETCH_ALL_MENU_ITEMS_FAILURE: "FETCH_ALL_MENU_ITEMS_FAILURE",
}
